import { HonestTable, IHonestTableColumn } from 'components/HonestTable/HonestTable'
import { NavBar } from 'components/NavBar/NavBar'
import { useState } from 'react'
import { useParams } from 'react-router-dom'
import { Flex, H1WithBack, PageFooter, PageWrapper } from 'styling/GlobalStyles'
import { BodyText, OtherText } from 'styling/Typography'
import { formatDateForDisplay, getParams, handlePagination } from 'utils/helpers'
import { StatusPill } from 'components/ui/StatusPill/StatusPill'
import { Cell } from 'components/HonestTable/HonestTable.styled'
import { clearOperationPlanAuditLogs, getOperationPlanAuditLogs } from 'features/operations/plansSlice'
import useQueryPagination from 'hooks/useQueryPagination'
import { useSelector } from 'react-redux'
import { RootState } from 'store'
import { Pagination } from 'components/Pagination/Pagination'
import { NoData } from 'components/NoData'
import { IGetAllOperationPlanAuditLogsSingleResponse } from 'types/api/operationsPlansApi.interface'
import { planAuditEventTypes } from '../plansData'

export const PlanAudit = () => {
    const { id } = useParams()
    const [params, setParams] = useState<any>(getParams({ location, limit: 30 }))
    const { auditLogs, auditLogsTotalPages } = useSelector((state: RootState) => state.operationPlans)

    const columns: IHonestTableColumn<IGetAllOperationPlanAuditLogsSingleResponse>[] = [
        {
            id: 'type',
            header: 'Event',
            sticky: true,
            minWidth: '10rem',
            cell: (item) => {
                const event = planAuditEventTypes.find((type) => type.value === item.type)
                return <StatusPill status={event?.tone ?? 'neutral'}>{event?.label || '-'}</StatusPill>
            },
        },
        {
            id: 'summary',
            header: 'Summary',
            minWidth: '20rem',
            cell: (item) => (
                <Cell>
                    <BodyText>{item.summary}</BodyText>
                </Cell>
            ),
        },
        {
            id: 'actor',
            header: 'Actor',
            cell: (item) => (
                <BodyText>{item.actor ? item.actor.firstName + ' ' + item.actor.lastName : 'System'}</BodyText>
            ),
        },
        {
            id: 'createdAt',
            header: 'Date',
            align: 'right',
            cell: (item) => <OtherText>{formatDateForDisplay(item.createdAt)}</OtherText>,
        },
    ]

    useQueryPagination({
        fetchFunctions: [getOperationPlanAuditLogs],
        cleanUpFunctions: [clearOperationPlanAuditLogs],
        params,
        functionParams: { id, params },
    })

    return (
        <>
            <NavBar />
            <PageWrapper>
                <Flex between center mb='16'>
                    <H1WithBack title='Audit Log' arrow />
                </Flex>
                {auditLogs?.length ? <HonestTable
                    columns={columns}
                    data={auditLogs}
                    keyField='id'
                /> : <NoData text='No audit logs to display' />}
            </PageWrapper>
            <PageFooter>
                <Pagination
                    setPage={(page) => handlePagination(page, setParams, 30)}
                    pageCount={Math.ceil(auditLogsTotalPages)}
                    forcePage={(params.page ? params.page : 1) - 1}
                />
            </PageFooter>
        </>
    )
}
